import { PersonStanding, Activity, Brain, Moon, HeartPulse, Baby } from "lucide-react";
import Reveal from "@/components/Reveal";
import { scrollToSection } from "@/components/Navbar";

const MOTIFS = [
  { icon: PersonStanding, title: "Douleurs de dos", text: "Lombalgies, sciatiques, douleurs vertébrales et tensions liées à la posture ou au travail." },
  { icon: Activity, title: "Nuque & épaules", text: "Cervicalgies, raideurs, épaules verrouillées, conséquences des écrans et du stress." },
  { icon: Brain, title: "Maux de tête", text: "Céphalées de tension, migraines : une approche globale pour en réduire la fréquence." },
  { icon: Moon, title: "Stress & sommeil", text: "Fatigue, tensions nerveuses, sommeil perturbé : relâcher pour mieux récupérer." },
  { icon: HeartPulse, title: "Suivi de grossesse", text: "Accompagnement en douceur avant et après la naissance, pour le confort de la maman." },
  { icon: Baby, title: "Nourrissons & enfants", text: "Plagiocéphalie, coliques, troubles du sommeil : des gestes tout en douceur." },
];

const Motifs = () => (
  <section id="motifs" className="relative overflow-hidden bg-ivory py-28 md:py-36" data-testid="motifs-section">
    <div aria-hidden="true" className="wash wash-beige blob -left-[10%] -top-[10%] h-[520px] w-[520px]" />
    <div aria-hidden="true" className="wash wash-sage-light blob-alt -bottom-[14%] -right-[10%] h-[560px] w-[560px]" style={{ animationDelay: "-7s" }} />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-medium uppercase tracking-[0.28em] text-gold">Motifs de consultation</p>
        <h2 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight text-anthracite md:text-5xl">
          Quand le corps demande de l'<em className="text-sage-dark">attention</em>
        </h2>
        <p className="mt-6 text-base font-light leading-relaxed text-taupe">
          L'ostéopathie s'adresse à tous, du nourrisson au senior. Voici les
          motifs les plus fréquents au cabinet — la liste n'est pas exhaustive.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {MOTIFS.map((m, i) => (
          <Reveal key={m.title} delay={(i % 3) * 0.08}>
            <div
              data-testid={`motif-card-${i}`}
              className="group h-full rounded-xl border border-beige bg-ivory p-9 transition-all duration-500 hover:-translate-y-1 hover:border-sage-light"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-sage-pale transition-colors duration-500 group-hover:bg-sage-light/60">
                <m.icon className="h-6 w-6 text-sage-dark" strokeWidth={1} />
              </span>
              <h3 className="mt-6 font-serif text-2xl font-light text-anthracite">{m.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-taupe">{m.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-14">
        <button
          data-testid="motifs-question-button"
          onClick={() => scrollToSection("#contact")}
          className="rounded-md border border-sage px-8 py-4 text-sm font-medium uppercase tracking-[0.14em] text-taupe transition-colors duration-300 hover:bg-ivory"
        >
          Une question sur votre motif ?
        </button>
      </Reveal>
    </div>
  </section>
);

export default Motifs;
